import { cx } from '@emotion/css'
import React from 'react'
import styles, { providerTheme, providerLogoTheme } from './styles'

const SocialSignupButton = ({ logo, name, provider, onClick }) => (
  <a className={styles.container} className={cx(styles.button, providerTheme(provider))} onClick={onClick}>
    <div className={cx(styles.providerLogoContainer, providerLogoTheme(provider))}>
      <img src={logo} alt={`${name} logo`} className={styles.logo} />
    </div>
    <span className={styles.name}>{name}</span>
  </a>
)

export default SocialSignupButton
